
export enum ProjectSubmitType {
	ONLINE = "ONLINE",			// 온라인, 제출 완료
	OFFLINE = "OFFLINE",		// 오프라인, 제출 완료
	PEN = "PEN",						// 대조완료
}